export default __webpack_public_path__ + "static/media/fileIcon.907e6f47.svg";